<template>
  <div class="playerVotes">
    <!-- 页头 -->
    <div class="page-header-style">
      <el-page-header @back="goBack" :content="$t('lang.title_playerVotes')"></el-page-header>
    </div>
    <!-- 筛选 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 投票时间datepicker -->
        <el-form-item :label="$t('lang.lab_votesTime')">
          <el-date-picker
            v-model="voteValues"
            type="datetimerange"
            :clearable="false"
            :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_votesTimeStart')"
            :end-placeholder="$t('lang.lab_votesTimeEnd')"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true,true)">{{$t('lang.btn_search')}}</el-button>
        <!-- 重置 -->
        <el-button type="primary" @click="onClear">{{$t('lang.btn_reset')}}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @sort-change="changeTableSort"
      >
        <!-- 昵称 -->
        <el-table-column prop="playerName" :label="$t('lang.lab_nickName')"></el-table-column>
        <!-- OpenId -->
        <el-table-column prop="voterId" :label="$t('lang.lab_openId')"></el-table-column>
        <!-- 投票时间 -->
        <el-table-column prop="voteTime" :label="$t('lang.lab_votesTime')" :sortable="'custom'">
          <template slot-scope="scope">
            {{ scope.row.voteTime|time }}
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:playerVotes
 *@Description:投票详情
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-08-04
 */
export default {
  name: '',
  components: {},
  data() {
    return {
      competeId: '', // 赛事id
      playerId: '', // 选手id
      /* 投票详情列表变量 */
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 列表数据
      voteValues: [], // 投票开始结束时间的绑定值
      startTime: '', // 投票开始时间
      endTime: '', // 投票结束时间
      /* 记忆筛选项值 */
      startTime_bak: '', // 备份-投票开始时间
      endTime_bak: '', // 备份-投票结束时间
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 获取投票详情列表数据
    getData() { 
      this.$get(`/player/onLine/playerVoteList?competeId=${this.competeId}&playerId=${this.playerId}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag, isSearch) { 
      if (flag) {
        this.pageNum = 1
      }
      console.log('onSearch', this.voteValues)
      this.startTime = ''
      this.endTime = ''
      if (this.voteValues != null) {
        if (this.voteValues.length > 0) {
          this.startTime = this.voteValues[0]
          this.endTime = this.voteValues[1]
        }
      }
      if (isSearch) {
        // 记忆筛选项值
        this.startTime_bak = this.startTime
        this.endTime_bak = this.endTime
      } else { 
        // 筛选项正确显示
        this.startTime = this.startTime_bak
        this.endTime = this.endTime_bak
      }
      this.$get(`/player/onLine/playerVoteList?competeId=${this.competeId}&playerId=${this.playerId}&startTime=${this.startTime}&endTime=${this.endTime}&sortName=${this.sortName}&sortFieldName=${this.sortFieldName}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 重置
    onClear() {
      this.voteValues = []
      this.startTime = ''
      this.endTime = ''
      this.startTime_bak = ''
      this.endTime_bak = ''
      this.pageNum = 1
      this.sortName = ''
      this.sortFieldName = ''
      this.getData()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false, false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false, false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true, false)
    },
    // 返回
    goBack() {
      window.history.go(-1)
    }
  },
  created() {
    this.competeId = this.$route.query.competeId
    this.playerId = this.$route.query.playerId
    if (this.competeId !== '' && this.playerId !== '') {
      this.getData()
    }
  },
  mounted() {}
}
</script>

<style lang='scss'>
</style>
